import type { VaultRewards } from '@/types/rewards'

export function checkActiveRewards(rewards: VaultRewards): boolean {
  return rewards.some((reward) => reward.apy['1day'] > 0 || reward.apy['7day'] > 0 || reward.apy['30day'] > 0)
}
